import { withDependencies } from '@wix/thunderbolt-ioc'
import type {
	BrowserWindow,
	IAppDidMountHandler,
	Experiments } from '@wix/thunderbolt-symbols'
import {
	BrowserWindowSymbol,
	ExperimentsSymbol
} from '@wix/thunderbolt-symbols'
import { accessibilityUtils } from './accessibilityUtils'

const accessibilitySiteFactory = (window: BrowserWindow, experiments: Experiments): IAppDidMountHandler => {
	const { addBrowserZoomForSPX } = accessibilityUtils(window, experiments)
	return {
		appDidMount() {
			const userAgent = window!.navigator.userAgent
			const isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
			// Safari 18.5 natively supports zooming for viewport units, so we don't need to add the browser zoom for SPX
			if (userAgent.includes('Chrome') || isMobile) {
				addBrowserZoomForSPX()
			}
		},
	}
}

export const AccessibilitySite = withDependencies(
	[BrowserWindowSymbol, ExperimentsSymbol] as const,
	accessibilitySiteFactory
)
